import APIS from 'src/constants/ApiConfig';
import HttpService from 'src/services/HttpService';

/**
 * 配药中心角色
 */
export const ROLE_DRUGSTORE = 'medcineSupplyCenter';
export type ROLE_DRUGSTORE = typeof ROLE_DRUGSTORE;

/**
 * 用户角色枚举
 */
export type USER_ROLE = ROLE_DRUGSTORE;

/**
 * 用户service
 * @class UserService
 */
class UserService {
  /**
   * 给用户赋予角色
   *
   * @memberof DrugStoreService
   */
  createUserRole(uuid: string, roleCode: USER_ROLE): Promise<void> {
    // 需要和userRoles一起使用，POST, /user/roles/<role_code>/users/<user_id>/
    return HttpService.put(`${APIS.userUrl(APIS.userRoles)}${roleCode}/users/${uuid}/`);
  }
}

export default new UserService();



// WEBPACK FOOTER //
// ./src/services/UserService.ts